export default __webpack_public_path__ + "static/media/spider.8a90bdae.png";